// helpers to get things from things we stash on window, likely from Django context

import cloneDeep from 'lodash/cloneDeep';

export function getCurrentUserInfo() {
    // get the current user info from the window object, set by Django context
    if (window.currentUserInfo) {
        console.log('Current user info found on window object:', window.currentUserInfo);
        return cloneDeep(window.currentUserInfo);  // so we don't mutate the original object
    } else {
        console.warn('No current user info found on window object');
        return null;
    }
}


export function fromCurrentUserInfo(key, defaultValue) {
    // get a specific key from the current user info, or return defaultValue if not found, or we don't have user info
    const userInfo = getCurrentUserInfo();
    if (userInfo && key in userInfo) {
        return userInfo[key];
    } else {
        console.warn(userInfo ? `Key '${key}' not found in current user info` : 'No current user info available!');
        return defaultValue;
    }
}